'use client'

import type { CSSProperties, ReactNode } from 'react'
import { Checkbox } from './Checkbox'

export interface ChecklistItem {
  label: ReactNode
  done?: boolean
  count?: ReactNode
  onToggle?: (next: boolean) => void
}

export function Checklist({
  title,
  items,
  onToggle,
  className,
  style
}: {
  title?: ReactNode
  items: ChecklistItem[]
  onToggle?: (index: number, next: boolean) => void
  className?: string
  style?: CSSProperties
}) {
  return (
    <div className={className ? `st-checklist ${className}` : 'st-checklist'} style={style}>
      {title && <h4>{title}</h4>}
      <ul>
        {items.map((it, i) => (
          <li key={i}>
            <Checkbox
              on={!!it.done}
              label={it.label}
              count={it.count}
              onChange={(next) => {
                it.onToggle?.(next)
                onToggle?.(i, next)
              }}
            />
          </li>
        ))}
      </ul>
    </div>
  )
}
